import { Card } from "@/src/components/shadcn/ui/card";

export function EhrInstructionsCard({ children }: { children: React.ReactNode }) {
  return <Card className="p-6 border bg-ehr/5 dark:bg-ehr/20 rounded-lg">{children}</Card>;
}
